// The round winner's spotlight: through the victory lap the arena dims, all but
// a soft-edged circle that follows the winner's head (each of their worms, after
// a twin): a hole in the dim, nothing lit on top. You watch them run their lap
// while the results are up. Its own layer, over the trails and heads; it fades
// out with them (GameCanvas contentFade) and is gone as the next round starts
// (no victory_lap event then).
//
// The head renderers note where they drew each head this frame
// (canvasState.heads, keyed by track: { x, y, playerId, at }), so the light is
// on the head exactly as drawn, predicted own worm included.
var DIM = 0.68;         // how dark the arena gets
var DIM_IN = 0.6;       // seconds to dim, from the lap's start
var LIGHT = 0.15;       // the light's radius, as a share of the arena's shorter side
var LIGHT_MIN_PX = 80;

export default function SpotlightRenderer({ gameState, canvas, canvasState }) {
    var context = canvas.getContext("2d");
    var prevRenderTime = null;
    var drawn = false;

    function lapEvent(time) {
        var events = gameState.gameEvents || [];
        for (var i = events.length - 1; i >= 0; i--) {
            if (events[i].type === "victory_lap") return events[i].time <= time ? events[i] : null;
        }
        return null;
    }

    function clear() {
        if (!drawn) return;
        context.clearRect(0, 0, canvas.width, canvas.height);
        drawn = false;
    }

    function render(renderTime) {
        if (renderTime === prevRenderTime) return;
        prevRenderTime = renderTime;
        var lap = lapEvent(renderTime);
        if (!lap || !lap.playerId) { clear(); return; }
        var heads = [];
        var noted = canvasState.heads || {};
        for (var k in noted) {
            var h = noted[k];
            if (h && h.at === renderTime && h.playerId === lap.playerId) heads.push(h);
        }
        if (!heads.length) { clear(); return; }
        var t = Math.max(0, Math.min(1, (renderTime - lap.time) / DIM_IN));
        var a = DIM * (1 - Math.pow(1 - t, 3));
        var w = canvas.width, hgt = canvas.height;
        var r = Math.max(LIGHT_MIN_PX, Math.min(w, hgt) * LIGHT);
        context.clearRect(0, 0, w, hgt);
        context.save();
        context.fillStyle = "rgba(3, 6, 13, " + a.toFixed(3) + ")";
        context.fillRect(0, 0, w, hgt);
        context.globalCompositeOperation = "destination-out";
        heads.forEach(function (h) {
            var g = context.createRadialGradient(h.x, h.y, 0, h.x, h.y, r);
            g.addColorStop(0, "rgba(0,0,0,1)");
            g.addColorStop(0.45, "rgba(0,0,0,0.9)");
            g.addColorStop(1, "rgba(0,0,0,0)");
            context.fillStyle = g;
            context.fillRect(h.x - r, h.y - r, r * 2, r * 2);
        });
        context.restore();
        drawn = true;
    }

    return { render: render };
}
